// extracted by mini-css-extract-plugin
module.exports = {"choice":"PollChoice_choice__d0Jbs","selected":"PollChoice_selected__jEhyw","choiceLabel":"PollChoice_choiceLabel___0xYD","percentBar":"PollChoice_percentBar__2-lr_"};